/**
 * Order Entry - Panel Enum
 * This enumeration contains identifiers for all panels and screens the comprize the order entry interface,
 */
export enum OEGammaLegType {
  ABOVE,
  BELOW,
  MID,
}
